export const formatCurrency = (amount, currency) => {
  const numericAmount = parseFloat(amount) || 0;
  return numericAmount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + ' ' + currency;
};

export const getProductPrice = (product, selectedCurrency) => {
  const price = product.prices?.[selectedCurrency] || product.prices?.USD || 0;
  return formatCurrency(price, selectedCurrency);
};
